module.exports = __webpack_public_path__ + "img/68-62ae94.png";